import script from "./CustomCakePage.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomCakePage.vue?vue&type=script&setup=true&lang=js"

import "./CustomCakePage.vue?vue&type=style&index=0&id=2222f346&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2222f346"]])

export default __exports__